import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { PaymentModule } from '../payment/payment.module';

import { LoginFormComponent } from './components/login-form/login-form.component';
import { RegisterPrivateAccountFormComponent } from './components/register-private-account-form/register-private-account-form.component';
import { LostPasswordFormComponent } from './components/lost-password-form/lost-password-form.component';
import { RegisterBusinessAccountFormComponent } from './components/register-business-account-form/register-business-account-form.component';
import { RegisterFormsWrapperComponent } from './components/register-forms-wrapper/register-forms-wrapper.component';

const COMPONENTS = [
  LoginFormComponent,
  RegisterPrivateAccountFormComponent,
  LostPasswordFormComponent,
  RegisterBusinessAccountFormComponent,
  RegisterFormsWrapperComponent,
];

@NgModule({
  imports: [
    NgbModule,
    FormsModule,
    CommonModule,
    PaymentModule,
    TranslateModule,
    ReactiveFormsModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
  ],
  exports: [
    ...COMPONENTS,
  ],
  declarations: [
    ...COMPONENTS,
  ]
})
export class UsersAuthModule {
}
